'use client';

import { useCallback } from 'react';

import { hasSignedCreatorContract } from '@/shared/lib/auth/permissions';
import { useAuthStore } from '@/shared/stores/auth-store';
import { useContractGateStore, type ContractGateSource } from '@/shared/stores/contract-gate-store';

/**
 * Wraps a creator action so unsigned creators are routed through the
 * Creator Agreement dialog before the action runs.
 *
 * Signed creators (and non-creators, who shouldn't reach the entry points
 * anyway) execute the action immediately. Unsigned creators see the dialog;
 * the action runs after acceptance via `runPendingAndClose`. `source` names
 * the entry point on the resulting creator_contract_* events.
 */
export function useRequireContract() {
  const user = useAuthStore((s) => s.user);
  const openGate = useContractGateStore((s) => s.open);

  return useCallback(
    (action: () => void, source: ContractGateSource) => {
      if (hasSignedCreatorContract(user)) {
        action();
        return;
      }
      openGate(action, source);
    },
    [user, openGate]
  );
}
